import { createTheme } from '@mui/material/styles';

// Color palette
const colors = {
  primary: '#44D482',
  primaryDark: '#2BA55E',
  primaryLight: '#6EEAA3',
  background: '#0A0A0F',
  backgroundLight: '#12121A',
  surface: '#1A1A24',
  surfaceLight: '#252532',
  text: '#FFFFFF',
  textSecondary: 'rgba(255, 255, 255, 0.7)',
  textMuted: 'rgba(255, 255, 255, 0.5)',
};

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: colors.primary,
      dark: colors.primaryDark,
      light: colors.primaryLight,
    },
    secondary: {
      main: colors.surfaceLight,
    },
    background: {
      default: colors.background,
      paper: colors.surface,
    },
    text: {
      primary: colors.text,
      secondary: colors.textSecondary,
    },
  },
  typography: {
    fontFamily: ['Space Grotesk', 'sans-serif'].join(','),
    h1: {
      fontFamily: 'Bebas Neue, sans-serif',
      fontWeight: 400,
      letterSpacing: '0.02em',
    },
    h2: {
      fontFamily: 'Bebas Neue, sans-serif',
      fontWeight: 400,
      letterSpacing: '0.02em',
    },
    h3: {
      fontFamily: 'Bebas Neue, sans-serif',
      fontWeight: 400,
      letterSpacing: '0.01em',
    },
    h4: {
      fontFamily: 'Space Grotesk, sans-serif',
      fontWeight: 600,
    },
    h5: {
      fontFamily: 'Space Grotesk, sans-serif',
      fontWeight: 500,
    },
    h6: {
      fontFamily: 'Space Grotesk, sans-serif',
      fontWeight: 500,
    },
    body1: {
      fontFamily: 'Space Grotesk, sans-serif',
      fontWeight: 400,
      lineHeight: 1.7,
    },
    body2: {
      fontFamily: 'Space Grotesk, sans-serif',
      fontWeight: 400,
      lineHeight: 1.6,
    },
    button: {
      fontFamily: 'Space Grotesk, sans-serif',
      fontWeight: 500,
      textTransform: 'none',
    },
    overline: {
      fontFamily: 'Fira Code, monospace',
      fontWeight: 400,
      letterSpacing: '0.1em',
    },
  },
  shape: {
    borderRadius: 16,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollbarWidth: 'thin',
          scrollbarColor: `${colors.primary} ${colors.surface}`,
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: colors.surface,
          },
          '&::-webkit-scrollbar-thumb': {
            background: colors.primary,
            borderRadius: '4px',
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '12px',
          padding: '12px 24px',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
});

export default theme;
export { colors };
